import { Component, OnDestroy, OnInit, ViewChild, Input, TemplateRef, ViewContainerRef, } from '@angular/core';

import { MysqlService } from './../../../../../services/mysql.service';
import { SubjectService } from './../../../../../api/subjectService';
import {DemoService} from '../../../../../demo.service';

import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable } from 'rxjs';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
// import { HotToastService } from '@ngneat/hot-toast';

@Component({
  selector: 'app-subject-service-list',
  templateUrl: './subject-service-list.component.html',
  styleUrls: ['./subject-service-list.component.css']
})
export class SubjectServiceListComponent implements OnInit {

  @Input() subject_service_id: number;
  subject_service: any;
  exactServiceMethod: any;
  serviceMethod: any;
  subjectRelationship: any;
  subjectServiceOutcome: any;
  brand: any;

  subject_location_status: any;
  subject_location_status_found: any;
 

  constructor(
    private route: ActivatedRoute, private router: Router,
    public _demoService: DemoService,
    private modalService: BsModalService,
    vcr: ViewContainerRef
  ) { }

  ngOnInit() {
    this.getSubjectService(this.subject_service_id);
  }


  getSubjectService(subject_service_id) {
    this._demoService.getSubjectService(subject_service_id).subscribe(
      data => { this.subject_service = data;
       // console.log("Done loadng USER");
       // console.log(this.users);
      let res = data[0]; 
    
      /*      */
       this.getServiceMethod(res.subject_service_method_id);
       this.getSubjectRelationship(res.fellow_occupants_relationship);
       this.getExactServiceMethod(res.exact_service_method);
       this.getSubjectServiceOutcome(res.subject_service_outcome_id);
       this.getBrandById(res.who_service); // get agent/brand that served
        this.getSubjectLocationStatus(res.subject_location_status_id);
        this.getSubjectLocationStatusFound(res.subject_location_status_found_id);
  
      },
      error => {
      //  console.error('Error Loading User!');
      // return Observable.throw(error);
      }
    ); }

    getServiceMethod(subject_service_method_id) {
      this._demoService.getServiceMethod(subject_service_method_id).subscribe(
        data => { this.serviceMethod = data; },
        err => console.error(err),
      );
      }


      getSubjectRelationship(subject_relationship_id) {
        this._demoService.getSubjectRelationship(subject_relationship_id).subscribe(
          data => { this.subjectRelationship = data; },
          err => console.error(err),
        );
        }


        getExactServiceMethod(subject_service_method_id) {
          this._demoService.getExactServiceMethod(subject_service_method_id).subscribe(
            data => { this.exactServiceMethod = data; },
            err => console.error(err),
          );
          }


          getSubjectServiceOutcome(subject_service_outcome_id) {
            this._demoService.getSubjectServiceOutcome(subject_service_outcome_id).subscribe(
              data => { this.subjectServiceOutcome = data; },
              err => console.error(err),
            );
            } 


            

            getBrandById(brand_id) {
              this._demoService.getBrandById(brand_id).subscribe(
                data => { this.brand = data; },
                err => console.error(err),
                () => console.log('done loading company')
              );
            }


  
            getSubjectLocationStatus(subject_location_status_id) {
              this._demoService.getSubjectLocationStatus(subject_location_status_id).subscribe(
                data => { this.subject_location_status = data; },
                err => console.error(err),
              );
              } 

              getSubjectLocationStatusFound(subject_location_status_found_id) {
                this._demoService.getSubjectLocationStatusFound(subject_location_status_found_id).subscribe(
                  data => { this.subject_location_status_found = data; },
                  err => console.error(err),
                );
                } 




}
